import z from "zod";
import { QualifierUser } from "@/api/user";

export const UserSchema = z
  .object({
    id: z.string(),
    name: z.string().nullish(),
    userName: z.string(),
  })
  .transform((data) => data as QualifierUser);
